// Staff copy for the Network section (every branch's setup at once, groups,
// publishing many).
// Native review pending (az, ru): the Azerbaijani and Russian here are a first
// draft. Change a phrase in all three languages at once, never in one.
import type { Phrase } from '../staffText'

export const network = {
  // Settings frame, Oct 2026: English only.
  'network.line': { en: 'Group branches and see what each runs.', az: '', ru: '' },
  'network.branches': { en: 'Branches', az: '', ru: '' },
  'network.branchCount': { en: '{n} branch|{n} branches', az: '', ru: '' },
  'network.groupCount': { en: '{n} group|{n} groups', az: '', ru: '' },
  'network.col.floor': { en: 'On the floor', az: '', ru: '' },
  'network.col.branches': { en: 'Branches', az: '', ru: '' },

  // admin/Network.tsx
  'network.allBranches': { en: 'All branches', az: 'Bütün filiallar', ru: 'Все отделения' },
  'network.groupFilter': { en: 'Show', az: 'Göstər', ru: 'Показать' },
  'network.outOfService': { en: 'Out of service', az: 'Xidmətdən kənar', ru: 'Не работает' },
  'network.notRead': { en: 'The branches’ setups could not be read.', az: 'Filialların ayarlarını oxumaq mümkün olmadı.', ru: 'Не удалось прочитать настройки отделений.' },

  // What happened, branch by branch

  // admin/BranchGroups.tsx
  'network.groups.eyebrow': { en: 'Groups', az: 'Qruplar', ru: 'Группы' },
  'network.groups.new': { en: 'New group', az: 'Yeni qrup', ru: 'Новая группа' },
  'network.groups.name': { en: 'Name', az: 'Ad', ru: 'Название' },
  'network.groups.members': { en: 'Branches in it', az: 'Daxil olan filiallar', ru: 'Отделения в группе' },
  'network.groups.count': { en: '{n} branch|{n} branches', az: '{n} filial', ru: '{n} отделение|{n} отделения|{n} отделений' },
  'network.groups.none': { en: 'No groups yet.', az: 'Hələ qrup yoxdur.', ru: 'Групп пока нет.' },
  'network.groups.nameNeeded': { en: 'A group needs a name.', az: 'Qrupun adı olmalıdır.', ru: 'У группы должно быть название.' },
  'network.groups.nameTaken': { en: 'There is already a group with that name.', az: 'Bu adda qrup artıq var.', ru: 'Группа с таким названием уже есть.' },
  'network.groups.nameTooLong': { en: 'A group’s name is at most 60 characters.', az: 'Qrupun adı ən çoxu 60 simvol ola bilər.', ru: 'Название группы — не длиннее 60 символов.' },
} satisfies Record<string, Phrase>
